import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { ElementRef, HostListener, ViewChild } from "@angular/core";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-collections",
  templateUrl: "./collections.component.html",
  styleUrls: ["./collections.component.scss"],
})
export class CollectionsComponent implements OnInit {
  @ViewChild("autoSuggestion") autoSuggestion!: ElementRef;

  slidesData: any = [];
  exclusiveData: any = [{}, {}, {}, {}];
  featuredData: any = [{}, {}, {}, {}];
  latestData: any = [{}, {}, {}, {}];
  popularData: any = [{}, {}, {}, {}];

  collectionData: any = [];
  othersData: any = [];

  constructor(
    private dataService: DataService,
    private meta: Meta,
    public router: Router
  ) {
    // this.meta.addTag({ name: "description", content: "Collections" });
  }
  typeahead: FormControl = new FormControl();

  searchKey = "Collections";

  suggestions: string[] = [];
  loader = false;
  imageLoad = true;

  getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  suggest() {
    if (this.typeahead.value.length > 0) {
      this.suggestions = this.collectionData.filter((c) =>
        c.collectionName
          .toLowerCase()
          .includes(this.typeahead.value.toLowerCase())
      );
    } else {
      this.suggestions = [];
    }
    //console.log(this.suggestions);
  }

  setSearchKey(data) {
    data == "illus"
      ? (this.searchKey = "Illustration")
      : (this.searchKey = "Collections");
  }

  async ngOnInit() {
    (await this.dataService.getCollectionBannerService()).subscribe(
      (singleservice) => {
        this.slidesData = [];
        this.slidesData = singleservice;
        //console.log(this.slidesData);
      }
    );
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        //console.log(singleservice);
        this.exclusiveData = [];
        this.featuredData = [];
        this.latestData = [];
        this.popularData = [];

        this.collectionData = [];
        this.collectionData = singleservice;
        // console.log(singleservice);
        for (let i = 0; i < singleservice.length; i++) {
          if (
            singleservice[i]["isExclusive"] &&
            this.exclusiveData.length < 4 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.exclusiveData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isFeatured"] &&
            this.featuredData.length < 4 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.featuredData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isLatest"] &&
            this.latestData.length < 4 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.latestData.push(singleservice[i]);
          }
          if (
            singleservice[i]["isPopular"] &&
            this.popularData.length < 4 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.popularData.push(singleservice[i]);
          }
          if (
            !singleservice[i]["isExclusive"] &&
            !singleservice[i]["isFeatured"] &&
            !singleservice[i]["isLatest"] &&
            !singleservice[i]["isPopular"] &&
            this.othersData.length < 4 &&
            !singleservice[i]["isAICollection"]
          ) {
            this.othersData.push(singleservice[i]);
          }
        }
        // this.loader = false;
        //console.log(this.exclusiveData);
        //console.log(this.slidesData);
      }
    );
  }

  getEncodedUrl(data) {
    return encodeURI(data);
  }

  navigateTo() {
    if (!this.typeahead.value || this.typeahead.value.trim() === "") {
      return;
    }

    this.router.navigate(["/search"], {
      queryParams: { value: this.typeahead.value, searchKey: this.searchKey },
    });
    //console.log("enter pressed");
  }

  @HostListener("document:click", ["$event"])
  handleClickOutside(event: MouseEvent) {
    const clickedInside = this.autoSuggestion?.nativeElement.contains(
      event.target
    );
    if (!clickedInside) {
      this.suggestions = [];
      if (this.typeahead?.setValue) {
        this.typeahead.setValue("");
      }
    }
  }
}
